export default "__VITE_ASSET__CaslkVo3__"